import React from 'react';
import './DealMetricCard.css';

interface DealMetricCardProps {
  title: string;
  value: string;
  description?: string;
  icon: string;
  accent?: 'green' | 'default';
}

const DealMetricCard: React.FC<DealMetricCardProps> = ({
  title,
  value,
  description,
  icon,
  accent = 'default',
}) => {
  return (
    <div className={`deal-metric-card accent-${accent}`}>
      <div className="deal-metric-icon">{icon}</div>
      <div className="deal-metric-content">
        <h3 className="deal-metric-title">{title}</h3>
        <div className="deal-metric-value">{value}</div>
        {description && <p className="deal-metric-description">{description}</p>}
      </div>
    </div>
  );
};

export default DealMetricCard;

